import { PartnerCountry } from "../types/data/partner";

export const formatCurrency = (
  price: number,
  currentCountry?: Partial<PartnerCountry>,
) => {
  const minimumFractionDigits = ["GTQ", "CRC"].includes(
    currentCountry?.currency || "",
  )
    ? 2
    : 0;
  if (currentCountry && currentCountry.locale) {
    return new Intl.NumberFormat(
      currentCountry.locale.replace("_", "-").substr(0, 5),
      {
        style: "currency",
        currency: currentCountry.currency,
        minimumFractionDigits,
        maximumFractionDigits: 2,
      },
    )
      .format(price)
      .replace(
        /\s+/g,
        ["CRC"].includes(currentCountry?.currency || "") ? "." : "",
      );
  }

  return price;
};
